import React, { Component } from 'react'

import gql from 'graphql-tag'

import MassMessageModal from '../Material/MassMessageModal'
import '../Drivers/DriversNew/DriversListContainer.css'
import { Row, Col, Input } from "reactstrap"
import BulkRepAssignment from "../Material/BulkRepAssignment"
import ConfirmationPopup from "../Material/ConfirmationPopup"
import ReservationModalNew from "../Reservations/Modals/ReservationModalNew"
import updateFilters from "../Functions/updateFilters"
import AdvancedFiltersControl from "../Filters/AdvancedFiltersControl"
import AppliedAdvancedFilters from "../Filters/AppliedAdvancedFilters"

import withApolloClient from '../withApolloClient'


const RepAssignment = gql`
mutation BulkRepAssignment ($input:BulkRepAssignmentMutationInput!){
    bulkRepAssignment(input:$input){
        errors{
            messages
        }
        ok
    }
}`

class ReservationsListHeader extends Component {
    constructor(props) {
        super(props)
        this.state = {
            openModal: "",
            filterValues: this.props.filterValues
        }
    }
    toggleModal = (modalName) => {
        this.setState({ openModal: this.state.openModal === modalName ? "" : modalName })
    }
    // Search is the only filter this header still owns -- everything else
    // moved to Advanced Filters.
    updateSearchTerm = (searchTerm) => {
        updateFilters({ ...this.props.filterValues, searchTerm }, [], this.props.navigate, this.props.location, this.props.setFilterValues)
    }
    unAssignReps = (unassignDriverMutations) => {
        let input = {
            objectIds: this.props.selectedDrivers.map(item => item.id),
        }
        this.props.apolloClient.mutate({
            mutation: RepAssignment,
            variables: { input }
        }).then((result) => {
            this.props.refetchQuery()
        })
    }

    render() {
        return (
            <Row className="align-items-center">
                {this.state.openModal === "MassMessageModal" &&
                    <MassMessageModal
                        handleClose={() => this.toggleModal("MassMessageModal")}
                        open={this.state.openModal === "MassMessageModal"}
                        drivers={this.props.selectedDrivers && this.props.selectedDrivers.length > 0 ? this.props.selectedDrivers.map(item => item.driver.id) : null}
                    />
                }
                {this.state.openModal === "assignReps" && <BulkRepAssignment
                    open={this.state.openModal === "assignReps"}
                    title={"Assign " + this.props.selectedDrivers.length + " Selected Reservations to Reps"}
                    selectedObjectIds={this.props.selectedDrivers.map(item => item.id)}
                    handleClose={() => this.toggleModal("assignReps")}
                    refetchQuery={this.props.refetchQuery}
                    groups={["Sales Team"]}
                />}
                {this.state.openModal === "confirmation" && <ConfirmationPopup
                    open={this.state.openModal === "confirmation"}
                    message={"Unassign " + this.props.selectedDrivers.length + " Selected Reservations"}
                    handleClose={() => this.toggleModal("confirmation")}
                    action={"Yes"}
                    confirmAction={this.unAssignReps}
                    color="danger"
                />}
                {this.state.openModal === "AddNewReservation" && (
                    <ReservationModalNew
                        handleClose={() => this.toggleModal("")}
                        open={this.state.openModal === "AddNewReservation"}
                        title={"Create New Reservation"}
                        refetchQuery={this.props.refetchQuery}
                        skip={true}
                        isUpdate={false}
                    />
                )}
                <Col xs={4}>
                    <span className="driver-search-filter">
                        <Input type="text" name="searchTerm" placeholder="Search" onChange={(e) => this.updateSearchTerm(e.target.value)} />
                        <i className="fa fa-lg fa-search search-icon" aria-hidden="true"></i>
                    </span>
                </Col>
                <Col xs={2}>
                    <AdvancedFiltersControl entity="reservation" presets={this.props.presets} setPresets={this.props.setPresets} defaultPresets={this.props.defaultPresets} />
                </Col>
                <Col xs={6} className="text-right mt-2">
                    <a className="driver-list-button" onClick={() => this.toggleModal("MassMessageModal")}>
                        Message Drivers | <i className="fa fa-commenting-o" aria-hidden="true"></i>
                    </a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    {this.props.activeTab === "all" && <>
                        <a className="driver-list-button" onClick={() => this.toggleModal("AddNewReservation")}>
                            New Reservations | <i className="fa fa-plus-square" aria-hidden="true"></i>
                        </a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </>}
                    {this.props.selectedDrivers && this.props.selectedDrivers.length > 0 &&
                        <>
                            <a className="driver-list-button" onClick={() => this.toggleModal("assignReps")}>
                                Assign Rep | <i className="fa fa-plus" aria-hidden="true"></i>
                            </a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <a className="driver-list-button" onClick={() => this.toggleModal("confirmation")}>
                                Unassign Reps | <i className="fa fa-minus" aria-hidden="true"></i>
                            </a>
                        </>
                    }
                </Col>
                <Col xs={12} className="mt-2">
                    {this.props.selectedDrivers && this.props.selectedDrivers.length > 0 && <span className="search-filter-preview">
                        <span> <i className="fa fa-times-circle" onClick={this.props.resetSelectedDrivers}></i> &nbsp;&nbsp; Selected Drivers</span>
                        {this.props.selectedDrivers.length}
                    </span>}
                    <AppliedAdvancedFilters entity="reservation" context={null} presets={this.props.presets} onPresetsChange={this.props.setPresets} />
                </Col>
            </Row>
        )
    }
}


export default withApolloClient(ReservationsListHeader)
